<ng-container *sm-has-env-flag="'auroraV1'">
    <aurora-icon-button
        class="sync-status-button"
        [ngClass]="syncClass"
        variant="ghost"
        size="xlarge"
        icon="sync"
        label="Live updates status">
    </aurora-icon-button>
    <!-- aurora-popover has no anchor/for API; it binds to its immediately preceding sibling, so keep this order. -->
    <aurora-popover [position]="popoverPosition" headline="Live Updates">
        <div class="sync-status-popover align-items-baseline">
            <div>Status: <span class="ms-1" [ngClass]="syncClass">{{status}}</span></div>
            <div *ngIf="status != 'Connected'" class="sync-status-message">
                You may still continue work as normal, but the experience may be diminished while the sync service is restored.
            </div>
        </div>
    </aurora-popover>
</ng-container>

<ng-container *sm-has-not-env-flag="'auroraV1'">
    <svg class="unity-icon-sync" role="button" [ngClass]="syncClass" [ngbPopover]="syncPop" [placement]="placement" [autoClose]="'outside'" container="body">
        <use xlink:href="#unity-icon-sync"></use>
        <line x1="35" y1="0" x2="0" y2="35" />
    </svg>
    <ng-template #syncPop>
        <div class="align-items-baseline">
            <div>Live Updates: <span class="ms-1" [ngClass]="syncClass">{{status}}</span></div>
            <div *ngIf="status != 'Connected'">
                You may still continue work as normal, but the experience may be diminished while the sync service is restored.
            </div>
        </div>
    </ng-template>
</ng-container>
